import React from 'react';

import { Stack } from '@lyearn/ui';

import Description from './Description';
import Title from './Title';
import { FormLayoutProps } from './types';

function FormLayout(props: FormLayoutProps) {
  return (
    <Stack className={props.className} direction="col">
      {props.children}
    </Stack>
  );
}

FormLayout.Title = Title;
FormLayout.Description = Description;

export default FormLayout;
